"use client";

import React, { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";
declare global {
  interface Window {
    Calendly?: {
      initPopupWidget: (options: {
        url: string;
      }) => void;
    };
  }
}
export default function Hero() {
  useEffect(() => {
    const calendlyCssHref = "https://assets.calendly.com/assets/external/widget.css";
    const calendlyScriptSrc = "https://assets.calendly.com/assets/external/widget.js";
    if (!document.querySelector(`link[href="${calendlyCssHref}"]`)) {
      const link = document.createElement("link");
      link.href = calendlyCssHref;
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
    if (!document.querySelector(`script[src="${calendlyScriptSrc}"]`)) {
      const script = document.createElement("script");
      script.src = calendlyScriptSrc;
      script.type = "text/javascript";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  const handleScheduleConsultation = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: "https://calendly.com/mfloresdo/30min"
      });
    }
    return false;
  };
  return <section className="relative w-full min-h-[560px] md:min-h-[700px] lg:min-h-[760px] overflow-hidden bg-black">
      {/* Image layer */}
      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1375869/img/fit_man_late_thirties_confident_pose.png" alt="Confident man representing IronPeak Men's Health" className="absolute inset-0 z-0 h-full w-full object-cover object-center" />

      {/* Overlay layer */}
      <div className="absolute inset-0 z-10 bg-gradient-to-r from-black/75 via-black/50 to-black/25"></div>
      <div className="absolute inset-0 z-10 bg-black/15"></div>

      {/* Content layer */}
      <div className="relative z-20 min-h-[560px] md:min-h-[700px] lg:min-h-[760px] flex items-center justify-center py-8 md:py-12 px-4">
        <div className="container">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 backdrop-blur-sm px-3 py-1.5 md:px-4 md:py-2 mb-4 md:mb-5">
              <ShieldCheck className="w-4 h-4 text-accent flex-shrink-0" />
              <span className="text-xs md:text-base font-semibold text-white leading-snug">
                Basecamp TRT — $150/month
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-white leading-tight mb-4 md:mb-6">
              Basecamp TRT for Texas Men Who Feel Like They’re Running on Empty
            </h1>

            <p className="text-lg md:text-2xl text-white font-medium leading-snug mb-4 md:mb-6 max-w-3xl mx-auto">
              Physician-led testosterone care for men with low energy, low
              drive, stubborn weight gain, and declining performance.
            </p>

            <p className="text-base md:text-xl text-white/90 leading-relaxed mb-6 md:mb-10 max-w-3xl mx-auto">
              We review your symptoms, labs, and health history to determine
              whether testosterone therapy is clinically appropriate — then
              build a personalized plan with ongoing medical oversight.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Button onClick={handleScheduleConsultation} className="w-full max-w-[340px] sm:w-auto sm:max-w-none bg-gradient-to-r from-accent to-accent-hover text-accent-foreground hover:from-accent-hover hover:to-accent-active px-5 md:px-8 py-4 h-auto min-h-12 text-sm md:text-base font-bold rounded-sm shadow-strong hover:shadow-xl hover:-translate-y-1 transform transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ring-2 ring-accent/20 hover:ring-accent/40 hover:scale-105 whitespace-normal text-center leading-snug">
                Book Your Free 30-Minute Consultation
              </Button>
              
              <div className="hidden sm:block text-sm md:text-base text-white/80 leading-relaxed">
                Available for qualified Texas patients
              </div>
            </div>

            <p className="hidden md:block text-sm text-white/70 leading-relaxed mt-5 max-w-2xl mx-auto">
              30-day satisfaction guarantee on IronPeak services. Treatment is prescribed only when medically appropriate after
              physician review of your symptoms, medical history, and lab
              results.
            </p>
          </div>
        </div>
      </div>
    </section>;
}